import { polarToCartesian as z } from "../PolarUtils.js";
import { getRadialCursorPoints as j } from "./getRadialCursorPoints.js";
function q(s, r, l) {
  var x, u, p, y;
  if (s === "horizontal")
    x = r.x, p = x, u = l.top, y = l.top + l.height;
  else if (s === "vertical")
    u = r.y, y = u, x = l.left, p = l.left + l.width;
  else if (r.cx != null && r.cy != null)
    if (s === "centric") {
      var h = r.cx, m = r.cy, T = r.innerRadius, b = r.outerRadius, g = r.angle, R = z(h, m, T, g), w = z(h, m, b, g);
      x = R.x, u = R.y, p = w.x, y = w.y;
    } else
      return j(r);
  return [{
    x,
    y: u
  }, {
    x: p,
    y
  }];
}
export {
  q as getCursorPoints
};
